import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { TabNav } from '../../components/nav/tabNav'
import { PageHeader } from '../../components/typography/PageHeader'
import Layout from '../../layout'
import CreateEssential from './createEssential'
import { ManageEssentialProducts } from './manageEssentialProducts'

const pageTabs = [
  {
    name: 'Essential Details',
    id: 'List details',
  },
  {
    name: 'Essential Products',
    id: 'List products',
  },
]

export const ManageEssentialDetails = () => {
  const [activeTab, setActiveTab] = useState(pageTabs[0].id)

  const { id } = useParams<{ id: string }>()

  return (
    <Layout>
      <div className="flex flex-col gap-10">
        <PageHeader
          title={
            activeTab === 'List details'
              ? id
                ? 'Edit Essential'
                : 'Create Essential'
              : 'Manage Essential Products'
          }
          className="!mb-0"
        />

        {id && (
          <TabNav
            tabs={pageTabs}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            className=""
          />
        )}

        {activeTab === 'List details' && <CreateEssential />}
        {activeTab === 'List products' && <ManageEssentialProducts />}
      </div>
    </Layout>
  )
}
